export { BaiduMapMarker } from './BaiduMapMarker';
export { type BaiduMapMarkerClickEvent } from './BaiduMapMarker.types';
